<template>
<div
	v-show="visible"
	class="list-group context-menu"
	:style="menuStyle"
	ref="contextMenu"
>
	<div class="list-group-item list-group-item-dark">
		<span class="fw-bold">{{ post?.shortName ? post?.shortName : post?.name }}</span>
	</div>
	<button
		type="button"
		class="list-group-item list-group-item-action"
		@click="$router.push({ name: 'post_control', params: { id: `${post.id}` } })"
	>
		Перейти
	</button>
	<button
		type="button"
		class="list-group-item list-group-item-action"
		:class="{
			'disabled': !accountStore.permissions.includes('manage_posts'),
			'btn': !accountStore.permissions.includes('manage_posts'),
			'btn-outline-light': !accountStore.permissions.includes('manage_posts'),
		}"
		@click="handleRemoveLocation(post)"
	>
		Видалити локацію
	</button>
</div>
</template>


<script>
import { useAccontStore } from '@/stores/AccountStore'

export default {
	props: {
		position: Object,
		visible: Boolean,
		post: Object,
		onRemoveLocation: Function,
		topShift: {
			type: Number,
			required: false,
			default: 0,
		},

		leftShift: {
			type: Number,
			required: false,
			default: 0,
		},
	},

	setup() {
		const width = 200;
		const height = 200;
		const accountStore = useAccontStore()

		return {
			width,
			height,
			accountStore,
		}
	},

	methods: {
		handleRemoveLocation(post) {
			this.onRemoveLocation(post)
		},
	},

	computed: {
		menuStyle() {
			const style = {
				position: "absolute",
				top: `${this.position.top}px`,
				left: `${this.position.left}px`,
				"max-width": `${this.width}px`,
				"max-height": `${this.height}px`,
			};

			// Отримання розмірів вікна браузера
			const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
			const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
			//console.log(`Window size: width = ${windowWidth}, height = ${windowHeight}`)

			// Перевірка, чи меню виходить за межі вікна знизу або справа
			if (this.position.top + this.height + this.topShift > windowHeight) {
				style.top = `${this.position.top - this.height}px`;
			}

			//console.log("this.position.left", this.position.left, "this.width", this.width, "windowWidth", windowWidth)
			if (this.position.left + this.width + this.leftShift > windowWidth) {
				style.left = `${this.position.left - this.width}px`;
			}

			return style;
		},
	},
};
</script>


<style scoped>
.context-menu {
	/* display: none; */
	position: absolute;
	background-color: #fff;
	border: 1px solid #ccc;
	box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
	z-index: 1000;

	font-family: Roboto, Helvetica, Arial, sans-serif;
	/* font-size:small; */
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;

	overflow-y: auto; /* Додаємо прокрутку по вертикалі при необхідності */
}
</style>
